import {
    Divider, Switch, message, Modal, Spin, Form, Input, InputNumber, Button, Select, Radio, Card, Space, Upload, Row, Col,
    Checkbox,
} from "antd";
import { PlusOutlined, } from "@ant-design/icons";
import { useEffect, useState } from "react";
import config from "../../../../@config/index";
import { getRequestHeader } from "../../../../@utils/request.js";
import QueryFormComponent from "../../components/queryFormComponent";
import TableComponent from "../../components/tableComponent";
import AuthComponent from '../../../../components/AuthComponent';
import ShopSelect from '../../../../components/BaseInfoSelects/StoreSelectBase'
import service from "../../../../@services"
import * as Utils from "../../../../@utils"
import useUpLoadGetProductList from "../../../../@hooks/useUpLoadGetProductList";




const PrefectureForm = (({ action, title, fn, id, defaultValue = null }) => {
    const importProductUrl = '/mallZone/mallZoneProduct/import'
    const { TextArea } = Input;
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    const [fileList, setPictureFileList] = useState([])

    // 图片上传之前的校验
    const beforeUpload = file => {
        const isJPG = file.type === 'image/jpeg'
        const isPNG = file.type === 'image/png'
        const isGif = file.type === 'image/gif'
        const isLt5M = file.size / 1024 / 1024 < 2
        if (!isJPG && !isPNG && !isGif) {
            message.error('上传图片只能是 png/jpg/gif 格式!');
        }
        if (!isLt5M) {
            message.error('上传图片大小不能超过 2MB!')
        }
        return (isJPG || isPNG || isGif) && isLt5M ? true : Upload.LIST_IGNORE
    }


    const onSuccess = () => {
        message.success("新增成功")
        setPageSetting({
            pageSize: 20,
            pageIndex: 1
        })
        setVisible(false)
        getList()
    }
    const { list: tableList, uploadBtn } = useUpLoadGetProductList({
        actionUrl: importProductUrl,
        requestData: { zoneId: id },
        onSuccess: onSuccess,
        title: "批量新增"
    })
    // 保存
    const save = () => {
        setLoading(true)
        const params = form.getFieldValue()
        form.validateFields().then(() => {
            fn(params).then(() => setLoading(false))
        }).catch(err => {
            setLoading(false)
        })
    }

    useEffect(() => {
        if (defaultValue) {
            setPictureFileList([{
                url: defaultValue.cover
            }])
            form.setFieldsValue({
                ...defaultValue,
                status: String(defaultValue.status)
            })
        } else {
            form.setFieldsValue({
                status: '1'
            })
        }
    }, [defaultValue])

    useEffect(() => {
        if (fileList.length && fileList[0].response) {
            form.setFieldsValue({
                ...form,
                cover: fileList[0].response.data
            })
        }
    }, [fileList])


    const [storeCodes, setStoreCodes] = useState([])

    const setDefault = (val, storeList) => {
        const arr = storeList.map(item => item.id)
        setStoreCodes(arr)
    }
    // 查询表单
    const fields = [
        {
            label: '所属门店',
            name: 'storeId',
            component: <ShopSelect keyVal='id' placeholder='全部' OnOptionsLoad={setDefault} />
        },
        {
            label: '商品',
            name: 'keyword',
            placeholder: "名称或编码"
        },
    ]
    // 表格头
    const columns = [
        {
            title: '序号',
            dataIndex: '',
            key: 'index',
            render: (text, record, index) => index + 1
        },
        {
            title: '商品编码',
            align: 'center',
            dataIndex: "outProductNo",
            key: 'outProductNo'
        },
        {
            title: '商品名称',
            align: 'center',
            dataIndex: 'name'
        },
        {
            title: '售价',
            align: 'center',
            dataIndex: "salePrice",
        },
        {
            title: '所属门店',
            dataIndex: 'storeName',
            key: 'storeName',
            align: 'center'
        },
        {
            title: '商品品类',
            align: 'center',
            dataIndex: "categoryName",
        },
        {
            title: '商品状态',
            align: 'center',
            render: (row) => {
                if (row.onlineShelves == 0) {
                    return '下架'
                } else if (row.onlineShelves == 1) {
                    return '上架'
                } else if (row.onlineShelves == 2) {
                    return '紧急下架'
                } else {
                    return '初始'
                }
            }
        },
        {
            title: '操作',
            align: 'center',
            key: "operate",
            render: (text, record, index) => {
                return action === "detail" ? null : (
                    <Space>
                        <AuthComponent authKey="/mallZoneProduct/delete/{id}">
                            <Button
                                type="link"
                                onClick={() => handleRecommend("delete", record)}
                            >
                                移除
                            </Button>
                        </AuthComponent>
                        <AuthComponent authKey="/mallZoneProduct/updateSort">
                            {index !== 0 && (
                                <Button
                                    type="link"
                                    onClick={() => handleRecommend("sort", record)}
                                >
                                    置顶
                                </Button>
                            )}
                        </AuthComponent>
                    </Space>
                );
            }
        }
    ]
    const [list, setList] = useState([])
    const [total, setTotal] = useState(0)
    const [pageSetting, setPageSetting] = useState({
        pageIndex: 1,
        pageSize: 20
    })
    const [searchForm, setSearchForm] = useState({
        storeId: '',
        keyword: '',
        zoneId: id
    })
    const [visible, setVisible] = useState(false)
    //    获取商品信息数据
    const getList = async () => {
        setLoading(true)
        const params = Object.assign({ zoneId: id, storeCodes: storeCodes }, searchForm, pageSetting)
        if (!params.storeId) params.storeCodes = storeCodes
        else delete params.storeCodes
        try {
            const res = await service.prefecture.mallZoneProductList(params)
            setTotal(res.recordCount)
            setList(res.result)
            setLoading(false)
        } catch (err) {
            setLoading(false)
        }
    }
    // 操作
    const handleRecommend = (type, val) => {
        if (type === 'delete') {
            try {
                service.prefecture.mallZoneProductDelete(val.id).then(() => {
                    message.success("移除成功")
                    setPageSetting({
                        pageIndex: 1,
                        pageSize: 20
                    })
                    getList()
                })
            } catch (err) {
                console.log(err)
            }
        } else {
            try {
                service.prefecture.mallZoneProductUpdateSort({
                    id: val.id,
                    sort: 1
                }).then(() => {
                    message.success("置顶成功")
                    setPageSetting({
                        pageIndex: 1,
                        pageSize: 20
                    })
                    getList()
                })
            } catch (err) {
                console.log(err)
            }
        }
    }
    // 搜索
    const searchFormFn = (val) => {
        setSearchForm({ ...val })
        setPageSetting({
            pageIndex: 1,
            pageSize: 20
        })
    }
    // 重置
    const reset = () => {
        setSearchForm({
            storeId: '',
            keyword: '',
            zoneId: id
        })
    }
    // 批量移除
    const batchReduce = () => {
        if (!selectRowData.length) return message.info("请选择数据")
        service.prefecture.mallZoneProductBatchDelete(
            selectRowData.map(item => item.id)
        ).then(res => {
            message.success("操作成功")
            setPageSetting({
                pageSize: 20,
                pageIndex: 1
            })
            getList()
        })
    }
    const downFile = () => {
        service.common.getFileTemplate({
            fileType: 'zoneProductTemplate'
        }).then((res) => {
            Utils.download(res, '导入商品模版.xlsx')
        })
    }

    const [selectRowData, setSelectRowData] = useState([])
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectRowData(selectedRows)
        },
    };
    useEffect(() => {
        id && getList()
    }, [id, storeCodes, searchForm, pageSetting])
    return (
        <Card style={{ textAlign: "left" }}>
            <Row>
                <Col span={22}>{title}</Col>
                <Col>
                    <AuthComponent authKey='/mallZone/create'>
                        {
                            action !== 'detail' ? <Button loading={loading} type="primary" onClick={save}>保存</Button> : <Button loading={loading} type="primary" onClick={fn}>返回</Button>
                        }
                    </AuthComponent>
                </Col>
            </Row>
            <Divider orientation="left">专区信息</Divider>
            <Form
                form={form}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 15 }}
            >
                <Form.Item
                    name="title"
                    label="专区名称"
                    rules={[{
                        required: true, validator: (rule, value, callback) => {
                            if (!value) return Promise.reject("请输入专区名称")
                            if (!!value && (value.length < 4)) return Promise.reject("输入限制4-50个字符")
                            return Promise.resolve()
                        }
                    }]}
                >
                    <Input disabled={action === 'detail'} style={{ width: '40% ' }} placeholder="请输入专区名称"
                        maxLength="50" />
                </Form.Item>
                <Form.Item label="专区封面" name="cover" rules={[{ required: true, message: "请上传专区封面" }]}>
                    <Upload
                        disabled={action === 'detail'}
                        action={config.BASE_API + "/common/uploadPictureFile"}
                        headers={getRequestHeader()}
                        listType="picture-card"
                        beforeUpload={beforeUpload}
                        fileList={fileList}
                        onChange={({ fileList }) => setPictureFileList(fileList)}
                    >
                        {fileList.length >= 1 ? null :
                            <div>
                                <PlusOutlined />
                                <div style={{ marginTop: 8 }}>上传</div>
                            </div>
                        }
                    </Upload>
                    <div>支持png/jpg/gif格式，建议尺寸750*384px</div>
                </Form.Item>
                <Form.Item
                    name="status"
                    label="专区状态"
                    rules={[{ required: true, message: "请选择专区状态" }]}
                >

                    <Radio.Group disabled={action === 'detail'} type='primary' buttonStyle="solid">
                        <Radio.Button value="1">启用</Radio.Button>
                        <Radio.Button value="0">禁用</Radio.Button>
                    </Radio.Group>
                </Form.Item>
                <Form.Item
                    name="remark"
                    label="备注"
                >
                    <TextArea disabled={action === 'detail'} rows={4} maxLength="500" />
                </Form.Item>
            </Form>
            {
                (action === 'edit' || action === 'detail') &&
                <>
                    <Divider orientation="left">商品信息</Divider>
                    {
                        action === 'edit' && <QueryFormComponent
                            name="PrefectureForm"
                            fields={fields}
                            haveBatchReduce
                            haveBatchAdd
                            batchAdd={() => setVisible(true)}
                            batchReduce={batchReduce}
                            authKey={{ search: '/mallZone/list' }}
                            onSearch={searchFormFn}
                            reset={reset}
                        />
                    }
                    <TableComponent
                        loading={loading}
                        columns={columns}
                        page={pageSetting}
                        total={total}
                        list={list}
                        rowSelection={{
                            type: 'checkbox',
                            ...rowSelection,
                        }}
                        addRecommend={() => handleRecommend()}
                        changePage={(val) => setPageSetting(val)}
                    />
                    <Modal
                        visible={visible}
                        title={'批量新增'}
                        centered
                        closable={true}
                        maskClosable={true}
                        onCancel={() => setVisible(false)}
                        onOk={() => setVisible(false)}
                        footer={false}
                    >
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            {uploadBtn}
                            <Button type="primary" style={{ marginLeft: "20px" }} onClick={downFile}>下载模板</Button>
                        </div>
                    </Modal>
                </>
            }

        </Card >
    );
});

export default PrefectureForm